import PropTypes from 'prop-types';
import React, { Component } from 'react';
import ReactSelect from '../../ReactSelect/ReactSelect';
import { FormGroup } from 'ps-design';
import UploadDropZone from 'ps-shared-ui/v3/UploadDropZone';
import Input from '../../Input/Input';
import { v4 as uuid } from 'uuid';
import classnames from 'classnames';

export default class Family extends Component {
  static propTypes = {
    app: PropTypes.object,
    jobFamily: PropTypes.string,
    jobFamilies: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    ),
    suggestFamily: PropTypes.arrayOf(PropTypes.string),
    saveJobFamily: PropTypes.func,
    display: PropTypes.bool,
    internalJobTitle: PropTypes.string,
    saveJob: PropTypes.func,
    workLocationExact: PropTypes.string,
    jobCode: PropTypes.string,

    //props for dropzone
    delayFile: PropTypes.array,
    jobDescription: PropTypes.object,
    jobDescriptionSuccess: PropTypes.bool,
    orgJobId: PropTypes.number,
    removeJobDescription: PropTypes.func,
    showDropZoneUploading: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    dzFile: PropTypes.any,
    onDrop: PropTypes.func,
    delayUpload: PropTypes.func,
    isMP: PropTypes.bool,
    getFileRejectReason: PropTypes.func,
    resetFileRejectReason: PropTypes.func,
    rejectReason: PropTypes.string,
    acceptedFileTypes: PropTypes.array,
    itemToUpload: PropTypes.string,
    isJdxEnabled: PropTypes.bool
  };

  constructor(props) {
    super(props);
    this.state = {
      jobTitle: this.props.internalJobTitle
    };
  }

  // change handler for family selection list
  familyChange(selection) {
    const newFamily = selection ? selection.value : null;
    const updatePayArgs = {};

    this.props.saveJobFamily(
      {
        family: newFamily,
        suggestionsDisplayed: this.props.suggestFamily
      },
      updatePayArgs
    );
  }

  // click handler for a suggested job family
  suggestionClick(suggestion) {
    this.familyChange({
      value: suggestion,
      label: suggestion
    });
  }

  handleJobTitleChange(event) {
    if (event.target.value) {
      this.setState({ jobTitle: event.target.value });
    } else {
      this.setState({ jobTitle: '' });
    }
  }

  handleJobTitleChangeBlur() {
    if (this.state.jobTitle === this.props.internalJobTitle) {
      return;
    }

    const jobDetails = {};
    const auditId = uuid();
    jobDetails.internalJobTitle = this.state.jobTitle;
    this.props.saveJob({
      auditId: auditId,
      orgJobTitle: this.state.jobTitle,
      orgJobCode: this.props.jobCode,
      workLocation: this.props.workLocationExact,
      orgJobId: this.props.orgJobId,
      jobDetails: jobDetails
    });
  }

  render() {
    const {
      display,
      jobFamilies,
      suggestFamily,
      jobFamily,
      dzFile,
      jobDescription,
      showDropZoneUploading,
      isMP,
      acceptedFileTypes,
      rejectReason,
      resetFileRejectReason,
      getFileRejectReason,
      itemToUpload,
      isJdxEnabled,
      app
    } = this.props;

    if (display && display !== true) {
      return;
    }

    let showDropZone = '';
    let prettyName = '';

    let showDropZoneUploadingClass = 'hidden';
    if (showDropZoneUploading) {
      showDropZoneUploadingClass = '';
    }

    let file = '';
    if (dzFile !== null) {
      file = dzFile;
    }
    if (jobDescription !== null && jobDescription !== undefined) {
      if (jobDescription.pretty_name) {
        showDropZone = 'hidden';
        prettyName = jobDescription.pretty_name;
      } else if (jobDescription.prettyName) {
        showDropZone = 'hidden';
        prettyName = jobDescription.prettyName;
      } else if (showDropZoneUploading) {
        showDropZone = 'hidden';
      } else if (jobDescription && typeof jobDescription !== 'object') {
        showDropZone = 'hidden';
        prettyName = jobDescription;
      } else {
        showDropZone = '';
        prettyName = '';
      }
    }
    const isJdxEnabledAndConfigured =
      isJdxEnabled &&
      app.accountMetaData.enableHRTMSIntegration &&
      app.accountMetaData.hrtmsEntityId &&
      app.accountMetaData.hrtmsUrl;

    return (
      <div className="row add-job__jobFamily">
        {/*Break this out into its own component */}
        <div className="add-job__jobFamily__container">
          {!isMP && (
            <FormGroup text="Internal Job Title" labelClassName="add-job__form-headers" className="col-sm-12">
              <Input
                type="text"
                className="add-job__input job-family__job-title"
                value={this.state.jobTitle}
                onChange={this.handleJobTitleChange.bind(this)}
                onBlur={this.handleJobTitleChangeBlur.bind(this)}
              />
            </FormGroup>
          )}
          {/*Break this out into its own component */}
          <FormGroup text="Job Family" labelClassName="add-job__form-headers" className="col-sm-12 job-family-dropdown">
            <ReactSelect
              className="add-job__jobFamily__dropdown--select"
              value={jobFamilies.filter(({ value }) => value === jobFamily)}
              options={jobFamilies}
              getOptionValue={option => option.value}
              getOptionLabel={option => option.label}
              onChange={this.familyChange.bind(this)}
              isClearable={true}
            />
          </FormGroup>
          <div className="add-job__popular-answers__list-row col-sm-12">
            <h6 className="add-job__popular-answers-heading">Suggested:</h6>
            <div className="add-job__popular-answers">
              {suggestFamily.map((answer, index) => {
                return (
                  <span
                    key={index}
                    onClick={this.suggestionClick.bind(this, answer)}
                    className="add-job__popular-answers__list"
                  >
                    {answer}
                  </span>
                );
              })}
            </div>
          </div>
        </div>
        {/*Break this out into its own component */}
        {!isMP && (
          <div
            className={classnames({
              'add-job__job-description-dropzone': true,
              'add-job__job-description-dropzone--hidden': isJdxEnabledAndConfigured
            })}
          >
            <div className="add-job__form-headers">Job Description</div>
            <div className="add-job__search-job__dropzone">
              <UploadDropZone
                showDropZoneUploading={showDropZoneUploading}
                prettyName={prettyName}
                fileName={file}
                onDrop={this.props.onDrop}
                delayUpload={this.props.delayUpload}
                removeFile={this.props.removeJobDescription}
                delayFile={this.props.delayFile}
                file={this.props.jobDescription}
                fileUploadSuccess={this.props.jobDescriptionSuccess}
                orgJobId={this.props.orgJobId}
                getFileRejectReason={getFileRejectReason}
                resetFileRejectReason={resetFileRejectReason}
                rejectReason={rejectReason}
                acceptedFileTypes={acceptedFileTypes}
                itemToUpload={itemToUpload}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}
